module.exports = __webpack_public_path__ + "img/s-lv-logo.8ad7c859.svg";